import React, { useState, useEffect } from 'react';
import "./Card.css"
import rateStar from "../../assets/images/home/rate.svg"
import StaticImage from "../../assets/images/package-img-default.png"


const Card = ({ image, title, location, days, price,currency,symbol, rate}) => {
      // const [bgImage, setBgImage] = useState(StaticImage);

      // useEffect(() => {
      //   if (!image) return; 

      //   const img = new Image();
      //   img.src = image;
      //   img.onload = () => setBgImage(image); 
      //   img.onerror = () => setBgImage(StaticImage); 
      // }, [image]);
  return (
    <div>
      <div className="card-container"
        style={{ backgroundImage: `url(${image})` }}></div>
      <div className="card-content">
        <div className="card-content-text">
          <div className="card-content-title">{title.length > 40 ? title.substring(0, 40) + '...' : title}</div>
          {location && (
            <div className="card-content-locaiton-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="16"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_113_1169)">
                  <path
                    d="M13.3451 0.0396761L13.4077 0.0361328L13.4845 0.0408572L13.5376 0.050306L13.6102 0.0709753L13.6734 0.0981407L13.7325 0.131802L13.7856 0.171369L13.8341 0.21566L13.8648 0.250503L13.9132 0.319007L13.9439 0.3757C13.9715 0.434755 13.9892 0.49696 13.997 0.562314L14 0.624912C14 0.6694 13.9953 0.712708 13.9858 0.754834L13.9652 0.827471L10.1077 11.5029C10.0346 11.6621 9.91728 11.7969 9.76979 11.8914C9.6223 11.986 9.45077 12.0362 9.27559 12.0361C9.11785 12.0365 8.9627 11.996 8.82518 11.9187C8.68767 11.8414 8.57247 11.7299 8.49075 11.595L8.45236 11.52L7.20867 6.82743L2.53386 5.59204C2.38811 5.52538 2.26242 5.42162 2.16935 5.29115C2.07629 5.16067 2.01911 5.00804 2.00354 4.84853L2 4.76054C2 4.42983 2.17776 4.12747 2.49665 3.95149L2.57933 3.91015L13.2193 0.0680225L13.2819 0.050306L13.3451 0.0396761Z"
                    fill="#A7A7A7"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_113_1169">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.0361328)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div className="card-content-locaiton">{location}</div>
            </div>
          )}
        </div>
        <div className="card-content-props">
          <div className="card-content-info">
            <div className="card-content-days">{days}</div>
            {/* <div className='card-content-rate'>
                        <img src={rateStar} />
                        <div>{rate} (24)</div>
                    </div> */}
          </div>
          <div className="card-content-price">{symbol}{price}</div>
        </div>
      </div>
    </div>
  );
}
 
export default Card